import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import chat from './modules/chat'; // 导入新模块 

Vue.use(Vuex)

const store = new Vuex.Store({
 modules: {
  user,
  chat // 注册新模块 
 },
 state: {  
  jobMessages: [], // 初始化为空数组  
  },  
  mutations: {  
    SET_JOB_MESSAGES(state, messages) {  
      state.jobMessages = messages;  
    },  
  },  
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js